import { NavigateFunction } from 'react-router';

import { defaultDates } from 'context/DateProvider/DateProvider';
import { FRAMES_PAGE_URL } from 'utils/defaults';

export const navigateToFrame = (navigate: NavigateFunction, id: string) => {
  navigate(`${FRAMES_PAGE_URL}/${id}?from=${defaultDates.from}&to=${defaultDates.to}`);
};
